import { render, staticRenderFns } from "./DmsUsersIndexComponent.vue?vue&type=template&id=6047f418"
import script from "./DmsUsersIndexComponent.vue?vue&type=script&lang=js"
export * from "./DmsUsersIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports